const testimonials = [
  {
    id: 1,
    imageUrl: "https://images.pexels.com/photos/6010793/pexels-photo-6010793.jpeg?_gl=1*11y452q*_ga*MTAzODIwMzc4Mi4xNzY5MTY5NjM0*_ga_8JE65Q40S6*czE3ODE2NzMxNDgkbzckZzAkdDE3ODE2NzMxNDgkajYwJGwwJGgw",
    name: "Sandeep ",
    title: "Perfect...!!!",
    subName: "Happy Patient",
    designation: "Hyderabad",
    rating: 5,
    desc: "The service exceeded my expectations. The staff was extremely supportive, and the entire process was smooth and hassle-free. I felt cared for at every step and would highly recommend it to anyone looking for quality healthcare support."
  },
  {
    id: 2,
    imageUrl: "https://images.unsplash.com/photo-1550792404-f62d4ce3bb3e?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NTZ8fHBhdGllbnR8ZW58MHx8MHx8fDA%3D",
    name: "Vikram Singh",
    title: "Loved it...!",
    subName: "Verified Patient",
    designation: "Bengaluru",
    rating: 4,
    desc: "A wonderful experience from start to finish. The consultation was easy to schedule, and the team was very responsive. Everything was handled professionally, making me feel confident and comfortable throughout."
  },
  {
    id: 3,
    imageUrl: "https://images.pexels.com/photos/6129152/pexels-photo-6129152.jpeg?_gl=1*11tr7vi*_ga*MTAzODIwMzc4Mi4xNzY5MTY5NjM0*_ga_8JE65Q40S6*czE3ODE2NzMxNDgkbzckZzAkdDE3ODE2NzMxNDgkajYwJGwwJGgw",
    name: "Sunita Reddy",
    title: "In Love..!!",
    subName: "Regular Customer",
    designation: "Mumbai",
    rating: 5,
    desc: "I have been using their services for several months, and the experience has always been exceptional. The quality of care, attention to detail, and timely support make them stand out from others."
  },
  {
    id: 4,
    imageUrl: "https://plus.unsplash.com/premium_photo-1664478101538-1740d023e48d?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjcxfHxwYXRpZW50fGVufDB8fDB8fHww",
    name: "Ramesh Kumar",
    title: "Awesome...",
    subName: "Long-term Patient",
    designation: "Pune",
    rating: 4.5,
    desc: "The team genuinely cares about patient satisfaction. Every interaction has been positive, and I appreciate the continuous improvements in service. It has made managing my healthcare much easier."
  },
  {
  id: 5,
  imageUrl: "https://images.pexels.com/photos/15277947/pexels-photo-15277947.jpeg?_gl=1*henwsz*_ga*MTAzODIwMzc4Mi4xNzY5MTY5NjM0*_ga_8JE65Q40S6*czE3ODE2NzMxNDgkbzckZzAkdDE3ODE2NzMxNDgkajYwJGwwJGgw",
  name: "Priya Sharma",
  title: "Excellent Service...!",
  subName: "Satisfied Patient",
  designation: "Hyderabad",
  rating: 5,
  desc: "I am extremely happy with the quality of care and support I received. The staff was friendly, professional, and always ready to help. The entire experience was comfortable, and I would gladly recommend their services to family and friends."
}
];

export { testimonials };